<template>
    <!-- button container -->
    <div class="button-container" v-bind:class="customclass" v-on:click="click_event" >

      <!-- label -->
      <div v-if="type === 'next'" class="button-label-next">
        <div class="utility upcase"><slot></slot></div>
      </div>

      <div v-else-if="type === 'back' || type === 'share'" class="button-label-back">
        <div class="utility upcase"><slot></slot></div>
      </div>

      <!-- arrow -->
      <div v-if="type === 'next'" class="button-arrow-next">
        <arrow :type="type"></arrow>
      </div>

      <div v-else-if="type === 'back' || type === 'share'" class="button-arrow-back">
        <arrow :type="type"></arrow>
      </div>

      <!-- background next -->
      <div v-if="type === 'next'" class="button-background-next">
        <svg class="button-background-svg" viewBox="0 0 221 48">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g>
              <path class="button-background-path" stroke-width="1" d="M0.5,0.5 L0.5,29.3873894 L19.3036863,47.5 L220.5,47.5 L220.5,0.5 L0.5,0.5 Z"></path>
            </g>
          </g>
        </svg>
      </div>

      <!-- background back -->
      <div v-else class="button-background-back">
        <svg class="button-background-svg" viewBox="0 0 220 48">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Button" transform="translate(110.000000, 24.000000) scale(-1, 1) translate(-110.000000, -24.000000) ">
              <path class="button-background-path" stroke-width="1" d="M0.5,0.5 L0.5,29.3873894 L19.3036863,47.5 L219.5,47.5 L219.5,0.5 L0.5,0.5 Z"></path>
            </g>
          </g>
        </svg>
      </div>

    </div>
</template>


<script>
  import arrow from '../atoms/arrow'
  export default {
    props: ['type', 'customclass', 'clickevent'],
    data () {
      return {
        default_clickevent () {
          return false
        }
      }
    },
    components: {
      'arrow': arrow
    },
    computed: {
      click_event () {
        if (!this.clickevent) {
          return this.default_clickevent
        }
        return this.clickevent
      }
    }
  }
</script>


<!-- scoped -->
<style scoped lang='scss'>

  @import '../../styles/variables';

  .button-container {
    position: relative;
    width: 221px;
    height: 48px;
    cursor: pointer;
    transition: opacity $transition-1;
    .utility {
      color: $blue;
      @media screen and (max-width: $md-max) , screen and (max-height: $md-height-max) {
        color: $white;
      }
    }
    &.button-disabled {
      opacity: 0.4;
      pointer-events: none !important;
    }
    &.button-disabled-invisible {
      opacity: 0;
      pointer-events: none !important;
    }
    &.nav-active, &:hover {
      .utility {
        color: $white;
      }
      .button-background-path {
        stroke: $white;
        fill: transparent;
      }
    }
    &.call-to-action {
      opacity: 1;
      .utility {
        color: $white !important;
      }
      .button-background-path {
        stroke: $orange !important;
        fill: $orange !important;
      }

    }
    &.call-to-action-blue {
      opacity: 1;
      .utility {
        color: $white !important;
      }
      .button-background-path {
        stroke: $white !important;
        fill: $nav-blue !important;
      }
    }
    @media screen and (max-width: $sm-max) {
      width: 120px;
      height: 36px;
    }
  }

  .button-label-next, .button-label-back {
    position: absolute;
    z-index: 2;
    top: 0;
    margin-top: 14.5px;
    .utility {
      transition: all $transition-1;
    }
    @media screen and (max-width: $sm-max) {
      margin-top: 9px;
    }
  }

  .button-arrow-next, .button-arrow-back {
    position: absolute;
    z-index: 2;
    top: 0;
    margin-top: 11.5px;
    @media screen and (max-width: $sm-max) {
      display: none;
    }
  }

  .button-label-next, .button-arrow-back {
    left: 0;
    margin-left: 48px;
    @media screen and (max-width: $sm-max) {
      margin-left: 36px;
    }
  }

  .button-label-back, .button-arrow-next {
    right: 0;
    margin-right: 48px;
    @media screen and (max-width: $sm-max) {
      margin-right: 36px;
    }
  }

  .button-background-next, .button-background-back {
    position: absolute;
    z-index: 1;
    pointer-events: none;
    top: 0;
    left: 0;
  }

  .button-background-svg {
    width: 220px;
    height: 48px;
    @media screen and (max-width: $sm-max) {
      width: 120px;
      height: 36px;
      transform: scale(1, 1.25);
    }
  }

  .button-background-path {
    stroke: $blue;
    fill: $white;
    transition: all $transition-1;
    @media screen and (max-width: $md-max) , screen and (max-height: $md-height-max) {
      stroke: $white;
      fill: transparent;
    }
  }

</style>

<!-- non-scoped (to traverse to arrow component) -->
<style lang="scss">
  @import '../../styles/variables';

  @media screen and (max-width: $md-max) , screen and (max-height: $md-height-max) {
    .button-container {
      .arrow-container {
        .fill-group {
          fill: $white !important;
        }
      }
    }
  }
  
  .button-container {
    .arrow-container {
      .fill-group {
        fill: $blue;
      }
    }
    &.nav-active, &:hover, &.call-to-action, &.call-to-action-blue {
      .arrow-container {
        .fill-group {
          fill: $white;
        }
      }
    }
    &:hover {
      .arrow-container {
        .bracket-left {
          transform: translateX(-3px);
        }
        .bracket-right {
          transform: translateX(3px);
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// button.vue?5bd1e926